import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import ApiReferencePage from './pages/ApiReferencePage'
import PlaygroundPage from './pages/PlaygroundPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import ConsolePage from './pages/ConsolePage'
import StatusPage from './pages/StatusPage'

function App() {
  return (
    <div className="min-h-screen bg-consciousness-deep text-awareness-silver">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/api" element={<ApiReferencePage />} />
        <Route path="/playground" element={<PlaygroundPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/console" element={<ConsolePage />} />
      </Routes>
    </div>
  )
}

export default App
